



























































import { Component, Vue } from 'vue-property-decorator';
import RdmCollapsableControlCard from '@/components/common/card/RdmCollapsableControlCard.vue';
import { channelModule } from '@/store/modules/moduleChannel';
import { tablePaginationOptions } from '@/utils/helpers';
import { constants } from '@/utils/constants';
import { httpModule } from '@/store/modules/moduleHttp';
import { ChannelBindingMode } from '@/models';
import {
  constructBindingRequests,
  filterChannelBindingRequestsByMode,
} from '@/utils/channelUtils';
import { Channel } from '@/models/ChannelModels';

@Component({
  components: {
    RdmCollapsableControlCard,
  },
})
export default class RateCardCreateConnectChannels extends Vue {
  private selectedChannels = [] as Channel[];
  private agreement = false;
  private connecting = false;
  private rateCardChannelsHeaders: Array<Record<string, any>> = [
    {
      text: 'Channel Name',
      align: 'left',
      filterable: false,
      value: 'name',
    },
    { text: 'Channel ID', align: 'left', sortable: true, value: 'id' },
  ];

  get Loading() {
    return channelModule.Loading;
  }

  get RateCard() {
    return channelModule.RateCard;
  }

  get ChannelBindings() {
    return channelModule.ConnectedChannels;
  }

  get RateCardSpr() {
    return channelModule.CreateCompanyRates;
  }
  get AvailableChannels() {
    return channelModule.AvailableChannels;
  }

  get ConnectChannelIsOpen() {
    return channelModule.FromConnectChannelState;
  }

  get CreateRateCardFormState() {
    return channelModule.CreateRateCardFormState;
  }

  set CreateRateCardFormState(state: boolean) {
    channelModule.setCreateRateCardFormState(state);
  }

  get paginationOptions() {
    return tablePaginationOptions(this.AvailableChannels);
  }

  private async mounted() {
    await httpModule.getCompanyChannels();
    await httpModule.getCompanyChannelsBindings();
  }

  destroyed() {
    channelModule.setFormConnectChanelState(false);
    channelModule.clearState();
    this.agreement = false;
    this.selectedChannels = [];
    this.connecting = false;
  }

  saveAndExit() {
    channelModule.setFormDetailsState(false);
    channelModule.setFormConnectChanelState(false);
    this.$router.push({ name: constants.routes.CHANNEL_RATE_CARDS });
  }
  /**
   * connectChannels
   * - iterate through and create any channel bindings
   * - iterate through and update any channel bindings
   * Bindings are processed one at a time so the Channel API never sees
   * concurrent updates to the same binding. The inputs are snapshotted so
   * navigating away mid-run cannot change them. The rate card is only
   * published once every binding call succeeded.
   */
  async connectChannels() {
    if (this.connecting) {
      return;
    }
    this.connecting = true;
    try {
      const rateCard = this.RateCard;
      const sprs = this.RateCardSpr;
      const bindings = [...this.ChannelBindings];
      const channels = [...this.selectedChannels];

      for (const channel of channels) {
        const requests = constructBindingRequests(
          rateCard,
          sprs,
          bindings,
          channel,
        );
        // create any bindings that need to be created
        const createRQs = filterChannelBindingRequestsByMode(
          requests,
          ChannelBindingMode.CREATE,
        );
        for (const binding of createRQs) {
          if (!(await channelModule.createChannelBinding(binding))) {
            await httpModule.getCompanyChannelsBindings();
            return;
          }
        }

        // update any bindings that need to be updated
        const updateRQs = filterChannelBindingRequestsByMode(
          requests,
          ChannelBindingMode.UPDATE,
        );
        for (const binding of updateRQs) {
          if (!(await channelModule.updateChannelBinding(binding))) {
            await httpModule.getCompanyChannelsBindings();
            return;
          }
        }
      }
      await httpModule.publishRateCard(rateCard.id);
      await this.$router.push({
        name: constants.routes.CHANNEL_RATE_CARD_VIEW,
        params: { id: rateCard.id },
      });
    } finally {
      this.connecting = false;
    }
  }

  toggleConnectChannelOpen() {
    channelModule.setFormConnectChanelState(!this.ConnectChannelIsOpen);
  }
}
